export default __webpack_public_path__ + "static/media/parkl-logo-green.8b7c852f.svg";